module.exports = __webpack_public_path__ + "static/video10-dd6accadbc12189ade7e68fa082b01fd.mp4";